import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CovenantTripRequestService } from 'src/app/service/covenant-trip-request/covenant-trip-request.service';
import { TripRequestService } from 'src/app/service/trip-request/trip-request.service';
import Swal from 'sweetalert2';
import * as moment from 'moment';

@Component({
  selector: 'app-covenant-run-trip-request-view',
  templateUrl: './covenant-run-trip-request-view.component.html',
  styleUrls: ['./covenant-run-trip-request-view.component.css']
})
export class CovenantRunTripRequestViewComponent implements OnInit {

  moment: any = moment;

  id: number;
  loading: boolean = true;
  tripRequest;

  constructor(
    private service: CovenantTripRequestService,
    private route: ActivatedRoute
  ) {
    this.route.params.subscribe(params => {
      this.id = params['id']
    });
  }

  ngOnInit(): void {
    this.getTripRequest();
  }

  getTripRequest() {
    this.service.getTripRequest(this.id).subscribe(data => {
      this.tripRequest = data;
      this.loading = false;
      console.log(this.tripRequest);

    }, error => {
      this.loading = false;
      Swal.fire("Erro", "Não foi possível carregar solicitação!", "error");
    });
  }

}
